module.exports = __webpack_public_path__ + "ptc_nakagawa_S1.be6a3a87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_S1.jpg
// module id = N5Vf
// module chunks = 0